import { ReactElement } from 'react'
import ConversionFunnelChart from 'app/components/analytics/ConversionFunnelChart'
import LocationSelector from 'app/components/analytics/LocationSelector'
import { PageScroll } from 'app/components/layout/PageScroll'
import MarketingDateRangeSelector from 'app/components/marketing/MarketingDateRangeSelector'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { ConversionType } from 'app/types/entities'
import { ConversionMetricsResponse } from 'types/analytics'
import { OptionType } from 'types/OptionType'

export type ConversionsDashboardShadcnComponentProps = {
  fromDate: string
  toDate: string
  locationOptions: OptionType[]
  selectedLocations: OptionType[]
  metrics: ConversionMetricsResponse | undefined
  isLoadingMetrics: boolean
  onDateChange: (fromDate: string, toDate: string) => void
  onLocationChange: (options: OptionType[]) => void
  onStageClick: (conversionType: ConversionType) => void
}

export function ConversionsDashboardShadcnComponent({
  locationOptions,
  selectedLocations,
  metrics,
  isLoadingMetrics,
  onDateChange,
  onLocationChange,
  onStageClick,
}: ConversionsDashboardShadcnComponentProps): ReactElement {
  const allLocationsOption = { name: `All Locations`, id: `0`, value: `` }

  return (
    <PageScroll
      contentClassName="pb-6"
      header={
        <div className="flex items-center justify-between">
          <PageHeaderComponent title="Google Conversion Tracking" className="pb-0" />
          <div className="flex items-center gap-4">
            <LocationSelector
              selectedOptions={selectedLocations}
              locationOptions={locationOptions}
              deselectAllOptions={[allLocationsOption]}
              onChange={onLocationChange}
            />
            <MarketingDateRangeSelector
              onDateChange={onDateChange}
              hideCompare
              defaultSelectorPreset="last_90_days"
              customLabelClassName="ml-2 text-xs text-default"
            />
          </div>
        </div>
      }
    >
      <div className="mb-6">
        <div className="inline-block rounded-lg border border-default bg-surface p-6 shadow-sm">
          <p className="text-sm font-medium text-subtle">Unique Conversions</p>
          <p className="text-2xl font-semibold text-strong">{metrics?.total ?? 0}</p>
        </div>
      </div>

      <div className="rounded-lg border border-default bg-surface p-6 shadow-sm">
        <ConversionFunnelChart metrics={metrics} isLoading={isLoadingMetrics} onStageClick={onStageClick} />
      </div>
    </PageScroll>
  )
}
